import { graphql } from '@/generated/gql';

export const SUPPLIER_MAP_DETAIL_QUERY = graphql(/* GraphQL */ `
  query SupplierMapDetail($id: ID!) {
    supplier(id: $id) {
      id
      name
      relationship
      address {
        countryCode
        city
        street
        postalCode
      }
      industry {
        id
        name
      }
      prequalificationTrades {
        name
        status
      }
      contact {
        fax
        phone
        email
        website
      }
    }
  }
`);
